/**
 * this is our DateTimePicker bundle, currently wrapping Eonasdan's
 * bootstrap-datetimepicker, which in turn requires moment.
 */

// less styling
require('@less/product-listing/main.less')

var $ = jQuery // eslint-disable-line no-undef

function getTotalPopup () {
  var $popup = $('#product-listing-total-popup')
  if ($popup.length === 0) {
    $popup = $(
      '<div id="product-listing-total-popup">' +
      '<div class="total-label">Gesamt</div>' +
      '<div class="total-currency">€</div>' +
      '<div class="total-amount">0,00</div>' +
      '</div>'
    )
    $popup.appendTo('body')
  }
  return $popup
}

function calculateProductTotal () {
  var total = 0
  $('input.product-listing-qty').each(function () {
    total += $(this).val() * Number($(this).attr('price'))
  })
  return total
}

function updateTotalPopup () {
  var total = calculateProductTotal()
  var $popup = getTotalPopup()
  if (total > 0) {
    let totalFormatted = (total - Math.floor(total)) !== 0
      ? total.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : total.toLocaleString('de-DE', { maximumFractionDigits: 0 })
    $popup.find('.total-amount').html(totalFormatted)
    $popup.animate({ width: 'show' }, 250)
  } else {
    $popup.animate({ width: 'hide' }, 250)
  }

  $popup.trigger('totalPopup.updated')
}

function fieldValueChanged () {
  var min = parseInt($(this).attr('min'))
  if (min) {
    let val = parseInt($(this).val())
    if (val < min) {
      $(this).val(min)
    }
  }

  var max = parseInt($(this).attr('max'))
  if (max) {
    let val = parseInt($(this).val())
    if (val > max) {
      $(this).val(max)
    }
  }

  updateTotalPopup()
}

$(function () {
  // listen to change on all .product-listing-qty
  $(document).on('change input keyup', 'input.product-listing-qty', fieldValueChanged)

  $(document).on('click', 'button.product-listing-plus, button.product-listing-minus', function () {
    var $field = $(this).closest('.input-group').find('.product-listing-qty')

    if ($field.attr('readonly')) {
      return false
    }

    if ($field.val() === '') {
      $field.val('0')
    }
    if ($(this).hasClass('product-listing-plus')) {
      $field.get(0).stepUp()
    } else {
      $field.get(0).stepDown()
    }
    $field.trigger('change')
    updateTotalPopup()
  })

  updateTotalPopup()
})
